import React from 'react';

import { ExperimentsModeContext } from '@neptune/shared/leaderboard-domain';

export function useExperimentsOnlyOptions(): [boolean, (value: boolean) => void] {
  const { experimentsOnlyEnabled, setExperimentsOnlyEnabled } =
    React.useContext(ExperimentsModeContext);

  return [experimentsOnlyEnabled, setExperimentsOnlyEnabled];
}
